import React from "react";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="error-boundary">
          <div className="bg-white border border-slate-200 rounded-xl p-10 max-w-md text-center space-y-4">
            <AlertTriangle size={36} className="mx-auto text-amber-500" />
            <h1 className="text-lg font-semibold text-[#003366]">Something went wrong</h1>
            <p className="text-xs text-slate-500 font-mono break-all">{String(this.state.error?.message || this.state.error)}</p>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 rounded-md bg-[#008080] text-white text-sm hover:bg-[#1a51db]"
              data-testid="error-boundary-reload"
            >
              Reload the app
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
